module.exports = __webpack_public_path__ + "c718e712cfc77c8fb17e97e8fb5223d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/documents.png
// module id = 57
// module chunks = 0